import {Component, EventEmitter, Inject, Injectable, Input, OnInit, Output} from '@angular/core';
import {NgbDateStruct, NgbCalendar, NgbDatepickerI18n, NgbCalendarPersian, NgbDate} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import * as moment from 'jalali-moment';
import {TranslateService} from '@ngx-translate/core';
import {ApiService} from '../../../../shared/services/api.service';
import {InternalService} from '../../../../shared/services/internal.service';
import {DatePipe} from '../../../../shared/pipe/datePipe';
const WEEKDAYS_SHORT = ['د', 'س', 'چ', 'پ', 'ج', 'ش', 'ی'];
const MONTHS = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];

@Injectable()
export class NgbDatepickerI18nPersian extends NgbDatepickerI18n {
  getWeekdayShortName(weekday: number) {
    return WEEKDAYS_SHORT[weekday - 1];
  }

  getMonthShortName(month: number) {
    return MONTHS[month - 1];
  }

  getMonthFullName(month: number) {
    return MONTHS[month - 1];
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.year}-${this.getMonthFullName(date.month)}-${date.day}`;
  }
}


@Component({
  selector: 'datepicker-jalali',
  templateUrl: './datepicker-jalali.html',
  styleUrls: ['./datepicker.css'],
  providers: [
    {provide: NgbCalendar, useClass: NgbCalendarPersian},
    {provide: NgbDatepickerI18n, useClass: NgbDatepickerI18nPersian}
  ]
})

export class NgbdDatepickerJalaliComponent implements OnInit {
  @Output() buttonClicked = new EventEmitter();
  id: number;
  @Input() newDate: any;
  @Input() model: any;
  @Input() lblText;
  date: { year: number, month: number };
  isDisabled = false;
  // @Input() dateJalaliWithDay;

  minDate;

  constructor(public calendar: NgbCalendar,
              public apiService: ApiService,public datePipe:DatePipe,
              public router: Router,
              public translate: TranslateService,
              public internalService: InternalService) {
  }

  ngOnInit() {
     // this.selectToday();
    // this.disableDay()

  }

  selectToday() {

    this.model = this.calendar.getToday();
    console.log(this.model,'ddddddddddddd');
  }

  onClick($event) {
    console.log($event);
   const dateShamsiToMiladi = moment.from(Number($event.year) + '-' + Number($event.month) +
      '-' + Number($event.day), 'fa').format('YYYY-MM-DD');
    this.newDate= this.datePipe.transform(dateShamsiToMiladi, 'false','d');
    // console.log(this.dateJalaliWithDay)
    console.log(this.newDate);
    // this.datemiladi = this.dateShamsiToMiladi.split('-');
    // const UTCDate = new Date(Number(this.datemiladi[0]), Number(this.datemiladi[1]) - 1, Number(this.datemiladi[2]));
    // this.timestamp = UTCDate.getTime();

    // this.dateJalaliWithDay = new DateJalaliWithDay();
    // this.dateJalaliWithDay = this.dateJalaliWithDay.transform(this.timestamp / 1000, true);
    //
    // this.newDate = this.timestamp / 1000;
    // localStorage.setItem('newDate',this.newDate);
    // if(this.newDate){
    //   const infoId = localStorage.getItem('infoId');
    //   const sectionId = localStorage.getItem('sectionId');
    //   const body={
    //     Date:Number(this.newDate),
    //     SecId:Number(sectionId),
    //     DoctorId:Number(infoId)
    //   }
    //   console.log(body)
    //   this.apiService.checkForReserve(body).subscribe((result:any)=>{
    //     console.log(result);
    //     this.internalService.resultForReserve=result.res;
    //   })
    // }
    this.buttonClicked.emit($event);
  }

  disableDay() {
    const d = this.calendar.getToday();
    this.minDate = {
      year: Number(d.year),
      month: Number(d.month),
      day: Number(d.day)
    };
  }

}
